import { Grid } from "@mui/material";
import {
  CandidateDetails,
  JobRequestDetails,
} from "../../../redux/Hire/jobRequestApi";
import Container from "../CandidateInerview/Container";
import CandidateInfoHeader from "./CandidateInfoHeader";

type Props = {
  candidate?: CandidateDetails;
  job?: JobRequestDetails;
};

const CandidateInfo = ({ candidate, job }: Props) => {
  return (
    <Grid
      container
      direction="column"
      bgcolor={"#fff"}
      border={"1px solid #EBECF0"}
      borderRadius={"8px"}
      padding={4}
      py={2}
    >
      <CandidateInfoHeader candidate={candidate} job={job} />
      <Container candidate={candidate} job={job} />
    </Grid>
  );
};

export default CandidateInfo;
